export { default as IntersectionPoint } from './IntersectionPoint.vue';
